import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Тумблер уведомлений о сообщениях чата (тост + звук) — пользовательский
// пресет, переживает перезаход; управляется из окна чата.
interface ChatNotifyState {
  enabled: boolean
  setEnabled: (enabled: boolean) => void
}

export const useChatNotifySettings = create<ChatNotifyState>()(
  persist(
    (set) => ({
      enabled: true,
      setEnabled: (enabled) => set({ enabled }),
    }),
    { name: 'telemost.chat-notifications' },
  ),
)
